import { HRJob } from '../types';

export abstract class BaseHRAdapter {
  abstract name: string;
  abstract connect(): Promise<boolean>;
  abstract fetchJobs(): Promise<HRJob[]>;
  abstract validateCredentials(): Promise<boolean>;
  
  protected formatJob(job: any): Partial<HRJob> {
    return {
      title: job.title || '',
      description: job.description || '',
      location: job.location || '',
      type: this.normalizeJobType(job.type),
      requirements: Array.isArray(job.requirements) ? job.requirements : [],
      source: this.name,
      sourceUrl: job.url || '',
    };
  }

  protected normalizeJobType(type: string): 'full-time' | 'part-time' | 'contract' {
    type = type.toLowerCase();
    if (type.includes('full')) return 'full-time';
    if (type.includes('part')) return 'part-time';
    return 'contract';
  }
}

